module.exports = __webpack_public_path__ + "media/images/undraw_empty_state-e33977d150994e661da5e2987c385490.svg";